/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, orderNumber: NonNullable<unknown> }} Orders_Docs_Generated_SuccessInputs */

const en_orders_docs_generated_success = /** @type {(inputs: Orders_Docs_Generated_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} document(s) generated for ${i?.orderNumber}`)
};

const es_orders_docs_generated_success = /** @type {(inputs: Orders_Docs_Generated_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se generaron ${i?.count} documento(s) para ${i?.orderNumber}`)
};

/**
* | output |
* | --- |
* | "{count} document(s) generated for {orderNumber}" |
*
* @param {Orders_Docs_Generated_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_docs_generated_success = /** @type {((inputs: Orders_Docs_Generated_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Docs_Generated_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_docs_generated_success(inputs)
	return es_orders_docs_generated_success(inputs)
});